import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toScheduleRows } from '../data/routesData';

export default function Schedule() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const schedules = toScheduleRows();

  // Fonction pour réserver depuis les horaires
  const handleBookFromSchedule = (routeString) => {
    const [departure, arrival] = routeString.split(' → ');
    const today = new Date().toISOString().split('T')[0];
    const params = new URLSearchParams({
      from: departure,
      to: arrival,
      date: today,
    });
    navigate(`/booking?${params.toString()}`);
  };

  return (
    <div className="bg-neutral-50 py-16">
      <div className="container mx-auto px-4">
        {/* EN-TÊTE */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-center mb-12"
        >
          <h1 className="text-5xl font-display font-bold text-neutral-900 mb-4">
            📅 {t('schedules_title')}
          </h1>
          <p className="text-xl text-gray-600">
            {t('schedules_subtitle')}
          </p>
        </motion.div>

        {/* TABLEAU */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-primary-900 to-primary-600 text-white">
                  <th className="p-6 text-left font-semibold">{t('route')}</th>
                  <th className="p-6 text-left font-semibold">{t('departure')}</th>
                  <th className="p-6 text-left font-semibold">{t('arrival')}</th>
                  <th className="p-6 text-left font-semibold">{t('price')}</th>
                  <th className="p-6 text-left font-semibold">{t('days')}</th>
                  <th className="p-6 text-left font-semibold">{t('action')}</th>
                </tr>
              </thead>
              <tbody>
                {schedules.map((item, i) => (
                  <motion.tr
                    key={`${item.route}-${i}`}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: i * 0.05 }}
                    className="hover:bg-neutral-50 transition"
                  >
                    <td className="p-6 font-bold text-neutral-900">{item.route}</td>
                    <td className="p-6">
                      <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-semibold">
                        {item.departure}
                      </span>
                    </td>
                    <td className="p-6">{item.arrival}</td>
                    <td className="p-6">
                      <span className="text-2xl font-bold text-accent-600">
                        {item.price.toLocaleString()}
                        <span className="text-sm text-gray-500 ml-1">XAF</span>
                      </span>
                    </td>
                    <td className="p-6">
                      <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">
                        {item.days}
                      </span>
                    </td>
                    <td className="p-6">
                      <button
                        className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition"
                        onClick={() => handleBookFromSchedule(item.route)}
                      >
                        {t('book_ticket')}
                      </button>
                    </td>
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* INFOS COMPLÉMENTAIRES */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition text-center">
            <div className="text-4xl mb-4">🎫</div>
            <h3 className="font-bold text-lg mb-2">{t('flexible_ticket')}</h3>
            <p className="text-gray-600 text-sm">{t('flexible_ticket_desc')}</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition text-center">
            <div className="text-4xl mb-4">💳</div>
            <h3 className="font-bold text-lg mb-2">{t('secure_payment')}</h3>
            <p className="text-gray-600 text-sm">{t('secure_payment_desc')}</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition text-center">
            <div className="text-4xl mb-4">📱</div>
            <h3 className="font-bold text-lg mb-2">{t('e_ticket')}</h3>
            <p className="text-gray-600 text-sm">{t('e_ticket_desc')}</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}